import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { installNumberInputWheelGuard } from './utils/numberInputWheelGuard'

const removeNumberInputWheelGuard = installNumberInputWheelGuard()

if (import.meta.hot) {
  import.meta.hot.dispose(removeNumberInputWheelGuard)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Initialize performance monitoring in development
if (import.meta.env.DEV) {
  console.log('🚀 Performance monitoring enabled. Press Ctrl+Shift+P to open dashboard.')
}
